<template>
  <vs-card class="cardx" style="display: inline">
    <div slot="header">
      <h3 align="center">{{ header }}</h3>
    </div>
    <vs-row>
      <vs-col vs-w="6" style="padding: 0">
        <vs-card style="border-radius: 15px; margin-bottom: 0; height: 215px">
          <vs-row id="center">
            <vs-list-header
              :title="gw1n"
              style="font-size: 15px"
              color="dark"
            ></vs-list-header>
          </vs-row>
          <vs-row>
            <img src="@/assets/images/gateway.png" width="100" height="100" />
            <vs-col vs-w="6" style="padding: 0; padding-left: 15px">
              <h6 class="font-weight-bold">MAC Address</h6>
              <h6 class="mt-1">{{ mac }}</h6>
              <h6 class="mt-2 font-weight-bold">
                Status
                <span v-if="isConnect != null">
                  <vs-icon
                    align="center"
                    icon="fiber_manual_record"
                    :color="isConnectColor"
                  >
                  </vs-icon>
                  <!-- <button @click="isConnect = false">false</button>
                  <button @click="isConnect = true">true</button> -->
                </span>
              </h6>
              <h6 class="mt-2 font-weight-bold">Last Seen</h6>
              <p class="mt-1">{{ LastSeen }}</p>
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>
      <vs-col vs-w="6" style="padding: 0; padding-left: 15px">
        <vs-card style="border-radius: 15px; height: 215px">
          <vs-row id="center">
            <vs-list-header
              title="Asset"
              style="font-size: 15px"
              color="dark"
            ></vs-list-header>
          </vs-row>
          <vs-row>
            <img
              id="asset"
              src="@/assets/images/sensor/C7.png"
              width="60"
              height="100"
            />
            <vs-col vs-w="6" style="padding: 0">
              <h6 class="font-weight-bold">Total Asset: {{ TotalWorker }}</h6>
              <h6 class="mt-2 font-weight-bold">Active Asset: {{ aw }}</h6>
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row>
    <vs-row
      vs-align="flex-end"
      vs-type="flex"
      vs-justify="space-between"
      vs-w="12"
    >
      <vs-col
        style="padding: 0"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="12"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-card style="border-radius: 15px; padding-left: 5">
          <vs-table :data="dataMergeManHour" max-items="5" pagination>
            <template slot="header">
              <vs-list-header
                title="Asset Tags"
                style="font-size: 18px"
                color="dark"
              ></vs-list-header>
            </template>
            <template slot="thead">
              <vs-th sortKey="name">
                Name <vs-icon icon="swap_vert" size="small"></vs-icon>
              </vs-th>
              <vs-th> Mac Address </vs-th>
              <vs-th> Distance </vs-th>
              <vs-th> rssi </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].name">
                  <vs-button
                    id="noWrap"
                    @click="viewSensor(tr)"
                    icon="signal_cellular_alt"
                    type="flat"
                    >{{ data[indextr].name }}</vs-button
                  >
                </vs-td>

                <vs-td :data="data[indextr].mac">
                  {{ data[indextr].mac }}
                </vs-td>
                <vs-td :data="data[indextr].dis">
                  {{ data[indextr].dis }}
                </vs-td>

                <vs-td :data="data[indextr].rssi">
                  {{ data[indextr].rssi }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-card>
      </vs-col>
    </vs-row>
  </vs-card>
</template>

<script>
import moment from "moment";
import { io } from "socket.io-client";
import { clearTimeout } from 'highcharts';

export default {
  props: {
    header: { type: String, default: "" },
    mac: { type: String, default: "" },
    TotalWorker: { type: Number, default: null },
    indoorTag: { type: Object, default: null },
  },
  computed: {
    isConnectColor: {
      get() {
        return this.isConnect == true ? "#32c040" : "gray";
      },
    },
  },
  data() {
    return {
      dataTable: [],
      isConnect: null,
      LastSeen: "",
      IntervalId: null,
      dataMergeManHour: [],
      aw: 0,
    };
  },
  mounted() {
    this.getData();
    // const io = require("socket.io-client");
    // const socket = io("https://1f82-18-140-161-60.ngrok.io/", {
    //   withCredentials: true,
    //   extraHeaders: {
    //     "my-custom-header": "abcd",
    //   },
    // });
    // // const socket = io("https://1f82-18-140-161-60.ngrok.io/");
    // socket.on("connect", () => {
    //   console.log(socket.id);
    // });
    // socket.on("message", (msg) => {
    //   console.log(msg);
    // });
    //   socket.emit("message","fuck you")

    
  },
  beforeDestroy() {
    clearTimeout(this.IntervalId);
  },
  methods: {
   async getData() {
     await this.$API.get("indoorgateway/" + this.mac).then((result) => {
        console.log(result);
        console.table([result.data[0].tagfound][0]);
        console.log("indoorTag", this.indoorTag);
        this.LastSeen = moment(
          result.data[0].lastdate.replace(".000Z", "")
        ).format("MMMM Do YYYY, h:mm:ss a");
        let timeDiff = moment().diff(
          moment(result.data[0].lastdate.replace(".000Z", "")),
          "m"
        );
        console.log(timeDiff);
        if (timeDiff <= 0) {
          this.isConnect = true;
          // this.isConnectColor = "primary";
        } else {
          this.isConnect = false;
          // this.isConnectColor = "gray";
        }
        console.log(this.isConnect);

        this.aw = result.data[0].tagfound.length;

        this.dataMergeManHour = [];
        if (this.indoorTag != null) {
          for (let i = 0; i < result.data[0].tagfound.length; i++) {
            const eli = result.data[0].tagfound[i];
            for (let j = 0; j < this.indoorTag.length; j++) {
              const elj = this.indoorTag[j];
              if (eli.mac === elj.mac) {
                let payload = {
                  mac: eli.mac,
                  name: elj.name,
                  dis: Math.pow(10, (-52 - eli.rssi) / (10 * 4)).toFixed(2),
                  rssi: eli.rssi,
                };
                this.dataMergeManHour.push(payload);
                // console.log("payload",this.dataMergeManHour)
                break;
              }
            }
          }
        }
      });
      this.IntervalId = setTimeout(() => {
      this.getData();
    }, 10*1000);
    },
    viewSensor(item) {
      // console.log(item.mac);
      this.$session.set("sensorname", item.name);
      this.$session.set("macname", item.mac);
      this.$session.set("type", item.type);

      // console.log(this.network,item)
      this.$router.push({
        name: "SensorDashboardIndoor",
        params: {
          sensorname: this.name,
          macname: this.mac,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#asset {
  margin: 0 10px;
}
</style>